import { useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Checkbox, Group, Modal, Stack, Text } from "@mantine/core";
import { IconUserShare } from "@tabler/icons-react";
import BackButton from "./BackButton";
import { notifications } from "@mantine/notifications";
import UserSelector from "../UserSelector/UserSelector";
import { useProfileStore } from "../../stores/UserStore";

const SelectionCopyToUser = ({
  handler,
  closeMenu,
  onFinish,
  isWorkflow,
  selectedIds,
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let fd = new FormData(e.target);
    let data = Object.fromEntries(fd);

    setLoading(true);

    let atLeastOneSuccess = false;

    for (const id of selectedIds) {
      try {
        await handler({
          id: id,
          user_id: user.id,
          with_models: data?.with_models === "on" ? true : false,
        });
        atLeastOneSuccess = true;
      } catch (error) {
        notifications.show({
          title: `Erreur #${id}`,
          message: `${lang.contact_lists.enrich.dialog.enrich_error}${id}.`,
          color: "red",
        });
      }
    }

    setLoading(false);

    if (atLeastOneSuccess) {
      close();
      onFinish?.();

      notifications.show({
        title: `Succès`,
        message: lang.contact_lists.copy_to_user.success,
        color: "green",
      });
    }
  };

  return (
    <>
      <Button
        variant="light"
        className="to-blue"
        justify="start"
        leftSection={<IconUserShare size={18} />}
        onClick={open}
        disabled={selectedIds?.length < 1}
      >
        {lang.contact_lists.copy_to_user.label}
      </Button>

      {opened && (
        <Modal
          opened={opened}
          size={"md"}
          onClose={handleClose}
          title={lang.contact_lists.copy_to_user.dialog.title_multiple.replace(
            "#",
            selectedIds?.length > 1 ? selectedIds?.length : "",
          )}
        >
          <Stack component={"form"} onSubmit={handleSubmit} gap={"xs"}>
            {/* <Text c={"dimmed"}>
              {lang.contact_lists.copy_to_user.dialog.text}
            </Text> */}

            <UserSelector
              label={lang.contact_lists.copy_to_user.dialog.user}
              placeholder={lang.contact_lists.copy_to_user.dialog.user}
              value={user}
              onChange={(v) => {
                setUser(v);
              }}
              withUnswitchedProfile
              required
              isFooter={
                useProfileStore.getState()?.unswitchedProfile?.level === "admin"
              }
              withinPortal={true}
            />

            {isWorkflow && (
              <Checkbox
                label="Copier aussi les modèles utilisés dans le scénario"
                name="with_models"
                size="md"
              />
            )}

            <Group justify="end" mt={"md"}>
              <BackButton onClick={handleClose} />

              <Button
                leftSection={<IconUserShare size={18} />}
                loading={loading}
                color="primary"
                type="submit"
              >
                {lang.contact_lists.copy_to_user.dialog.submit_button}
              </Button>
            </Group>
          </Stack>
        </Modal>
      )}
    </>
  );
};

export default SelectionCopyToUser;
